(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cbod-certified-resellers"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cbod-resellers')) {
    customElements.define('cbod-resellers', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initializeReveal());
      }

      initializeReveal() {
        this.observer?.disconnect();
        if (
          this.dataset.animate !== 'true' ||
          window.Shopify?.designMode ||
          window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
          !('IntersectionObserver' in window) ||
          !Element.prototype.animate
        ) return;

        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.stopMotion = () => {
          if (!this.motionQuery.matches) return;
          this.observer?.disconnect();
          this.getAnimations({ subtree: true }).forEach(animation => animation.cancel());
        };
        this.motionQuery.addEventListener('change', this.stopMotion);

        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            const element = entry.target;
            this.observer.unobserve(element);
            if (element.dataset.cbodRevealed === 'true') return;
            element.dataset.cbodRevealed = 'true';

            const mobile = window.matchMedia('(max-width: 699px)').matches;
            const delay = mobile ? 0 : Number(
              getComputedStyle(element).getPropertyValue('--cbod-delay').trim()
            ) || 0;

            element.animate(
              [
                { opacity: 0, transform: 'translateY(10px)' },
                { opacity: 1, transform: 'translateY(0)' }
              ],
              { duration: 650, delay, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'backwards' }
            );
          });
        }, { threshold: 0.08 });

        this.querySelectorAll('[data-cbod-reveal]').forEach(element => {
          if (element.dataset.cbodRevealed !== 'true') this.observer.observe(element);
        });
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.observer?.disconnect();
        this.motionQuery?.removeEventListener('change', this.stopMotion);
        this.getAnimations({ subtree: true }).forEach(animation => animation.cancel());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
